module.exports = __webpack_public_path__ + "img/28_83.48fda12d.png";